import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newcustomer-header',
  templateUrl: './newcustomer-header.component.html',
  styleUrls: ['./newcustomer-header.component.scss']
})
export class NewcustomerHeaderComponent implements OnInit {

  isDetailsPageShow: any;
  constructor() { }

  ngOnInit() {
  }

}
